module.exports = __webpack_public_path__ + "static/logo_white-3e17cc72949b979c56dc65e05a2183e9.png";